var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.is_wfm)?_c('OlliPayWfm'):_c('OlliPayStd')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }